import React from 'react'
import { RouteWithoutLayout } from 'react-admin';
import DeleteAccount from './DeleteAccount';

export default [
  <RouteWithoutLayout key="dashboard" path="/delete_account" exact component={DeleteAccount}/>
]
